<template>
  <FeaturesSection
    :features="apiFeatures"
    tag="Features"
    title="Easy-to-use APIs"
    description="LayUp integrates at any level bringing an unparalleled recurring payments solution for business."
    hasButton
  />
</template>

<script setup lang="ts">
import type { Feature } from './FeaturesSection.vue';
import FeaturesSection from './FeaturesSection.vue';

const apiFeatures = [
  {
    icon: 'SquaresIntersect',
    title: 'Pre-built integrations',
    description: 'Connect LayUp to your business software to enjoy seamless and secure transactions.',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: '/business/plugins',
  },
  {
    icon: 'Smile',
    title: 'API documentation',
    description: 'We help you simplify and automate processes, leaving time to focus on acquisition and growth.',
    buttonLabel: 'View documentation',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: 'https://documentation.layup.co.za/',
  },
  {
    icon: 'ChartPie',
    title: 'Point of sale',
    description: 'Process transactions, accept payments from customers and keep track of sales efficiently.',
    buttonLabel: 'Find out more',
    buttonStyle: 'link-light' as Feature['buttonStyle'],
    buttonLink: '/business',
  },
];
</script>
